import Lenis from 'lenis'
import 'lenis/dist/lenis.css'

window.Lenis = new Lenis({
  autoRaf: true,
  duration: 1.2,
  prevent: (node) => {
    if (document.body.classList.contains('prevent-lenis-scroll')) {
      return node === document.body || node === document.documentElement
    }
    if (node.closest('.no-lenis')) {
      return true
    }
    return false
  },
})
